// extracted by mini-css-extract-plugin
export default {"card":"Kegiatan_card__S7YTp"};